import React, { Component } from "react";

function TableShowAs({ limit, setLimit, set }) {
  return (
    <select
      onChange={e => {
        set(e.target.value);
      }}
      style={{
        border: "none",
        backgroundColor: "#eee",
        borderRadius: "5px",
        padding: "3px 2px",
      }}
    >
      <option selected={limit === "15" ? true : false} value="15">
        15 ردیف
      </option>
      <option selected={limit === "25" ? true : false} value="25">
        25 ردیف
      </option>
      <option selected={limit === "50" ? true : false} value="50">
        50 ردیف
      </option>
      <option selected={limit === "100" ? true : false} value="100">
        100 ردیف
      </option>
    </select>
  );
}

export default TableShowAs;
